<div class="tag-chip" [ngClass]="tagClassName">
  <span class="tag-chip-name">{{ tag?.name }}</span>

  <button
    *ngIf="removable"
    type="button"
    class="tag-chip-remove"
    (click)="onRemoveTag($event)"
    [attr.aria-label]="'service-request.tag.remove' | translate"
  >
    <span class="tag-chip-remove-icon" aria-hidden="true">×</span>
  </button>
</div>
